export const buttonWithPrefixStyle = `
  border-left: none !important;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
`;
export const buttonWithPrefixVerticalStyle = `
  border-top: none !important;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
`;
export const buttonWithSuffixStyle = `
  border-right: none !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
`;
export const buttonWithSuffixVerticalStyle = `
  border-bottom: none !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
`;